enum MastersSectionContent {
  SINGLE = 'SINGLE',
  EP = 'EP',
  ALBUM = 'ALBUM',
}

export default MastersSectionContent;
